import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
    standalone: true,
    name: 'image'
})
export class ImagePipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    // If value is null or undefined, return the default.svg no-photo path
    if (value == null || value === undefined || value === '') {
      return environment.storageUrl + environment.noPhotoUrl;
    }
    // Otherwise, return the original value
    return environment.productImageUrl + value;
  }

}
